import { Routes } from '@angular/router';

import { moviesTypeResolver } from '@usheru-hff/sdk/movie';
import { buildDefaultParamsGuard } from '@usheru-hff/sdk/route';

const useLocCountry = true;
export const APP_ROUTES: Routes = [
  {
    path: 'movies/tag/past-events',
    canActivate: [buildDefaultParamsGuard({ sort: 'locReleaseDate', sortDesc: 'true' }, useLocCountry)],
    loadComponent: () => import('./pages/past-events-page.component').then(m => m.PastEventsPageComponent),
    resolve: {
      moviesTypeResolver
    }
  },
  {
    path: 'movies',
    loadChildren: () =>
      import('@usheru-hff/movies-catalogue/feature-movies-page').then(m => m.MoviesCatalogueFeatureMoviesPageModule)
  },
  {
    path: 'movie-site',
    loadChildren: () =>
      import('@usheru-hff/branded-page/ui-branded-templates').then(m => m.BrandedPageUiBrandedTemplatesModule)
  },
  {
    path: 'about',
    loadComponent: () => import('@usheru-hff/custom-page/feature-custom-page').then(m => m.CustomPageComponent),
    pathMatch: 'full',

    data: { custompage: 'about' }
  },
  {
    path: 'movie',
    loadChildren: () =>
      import('@usheru-hff/movie-detail/feature-movie-detail-page').then(m => m.MoviesDetailFeatureMovieDetailPageModule)
  },
  // VALIDATION ROUTES
  {
    path: 'double-opt-in',
    loadChildren: () =>
      import('@usheru-hff/shared/feature-validation-page').then(m => m.SharedFeatureValidationPageModule)
  },
  //HOME
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // NEWS
  {
    path: 'news-article',
    loadChildren: () => import('@usheru-hff/news/feature-news-page').then(m => m.NewsFeatureNewsPageModule)
  },
  {
    path: 'not-found',
    loadChildren: () => import('@usheru-hff/hff-common/ui-not-found-page').then(m => m.HffCommonUiNotFoundPageModule)
  },
  //CUSTOM PAGE
  {
    path: ':custompage',
    loadComponent: () => import('@usheru-hff/custom-page/feature-custom-page').then(m => m.CustomPageComponent)
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
